<template>
    <div class="row justify-content-center" :id="id">
        <div class="col-md-11">
            <div class="row fotoDerecha my-5" v-if="pos == 'fotoderecha'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-7 pl-lg-5 m-0 contImagen order-lg-12">
                    <img :src="imagen" class="img-fluid" />
                </div>
                <div class="col-lg-5 text-left py-4 order-lg-1">
                    <hr />
                    <h3 v-html="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                    <button href="javascript:void('');" v-scroll-to="'#tresPasos'" class="btn btn-primary">
                        <img src="@/assets/images/flechalinks.svg" class="flechalinks" />
                    </button>
                </div>
            </div>
            <div class="row fotoIzquierda my-5" v-if="pos == 'fotoizquierda'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-7 pr-lg-5 m-0 contImagen">
                    <img :src="imagen" class="img-fluid" />
                </div>
                <div class="col-lg-5 text-left py-4">
                    <hr />
                    <h3 v-html="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                    <a :href="linkURL" class="btn btn-dos" target="_blank"><img src="@/assets/images/link-azul.svg"
                            class="iconoAzul" />Formulario de diagnóstico</a>
                </div>
            </div>
            <div class="row fotoArriba my-5" v-if="pos == 'fotoarriba'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-12 m-0 contImagen">
                    <img :src="imagen" class="img-fluid" />
                </div>
                <div class="col-lg-12 text-left py-4">
                    <h3 v-html="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                    <a href="tel:+523335633993" class="btn btn-dos menos-margen"><img src="@/assets/images/tel-azul.svg"
                            class="iconoAzul" />Llámanos por teléfono</a>
                    <a href="https://wa.me/523310735383?text=Web rmzasesores.com: "
                        class="btn btn-dos movil menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                            class="iconoAzul" />Mándanos un WhatsApp</a>
                    <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: "
                        class="btn btn-dos escritorio menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                            class="iconoAzul" />Mándanos un WhatsApp</a>
                    <a href="javascript:void('');" v-clipboard:copy="linkURL" class="btn btn-dos menos-margen"><img
                            src="@/assets/images/link-azul.svg" class="iconoAzul" />Copia
                        y comparte esta información</a>
                </div>
            </div>
            <div class="row conAviso my-5" v-if="pos == 'conaviso'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-6 text-left py-4">
                    <hr />
                    <h3 v-html="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                    <div class="escritorio">
                        <a href="tel:+523335633993" class="btn btn-dos menos-margen"><img src="@/assets/images/tel-azul.svg"
                                class="iconoAzul" />Llámanos por teléfono</a>
                        <a href="https://wa.me/523310735383?text=Web rmzasesores.com: "
                            class="btn btn-dos movil menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                                class="iconoAzul" />Mándanos un WhatsApp</a>
                        <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: "
                            class="btn btn-dos escritorio menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                                class="iconoAzul" />Mándanos un WhatsApp</a>
                        <a href="javascript:void('');" v-clipboard:copy="linkURL" class="btn btn-dos menos-margen"><img
                                src="@/assets/images/link-azul.svg" class="iconoAzul" />Copia y comparte esta
                            información</a>
                    </div>
                </div>
                <div class="col-lg-6 m-0 p-0 contImagen">
                    <div class="aviso p-4 pt-5" v-html="aviso"></div>
                </div>
                <div class="movil mt-5 ml-4">
                    <a href="tel:+523335633993" class="btn btn-dos menos-margen"><img src="@/assets/images/tel-azul.svg"
                            class="iconoAzul" />Llámanos por teléfono</a>
                    <a href="https://wa.me/523310735383?text=Web rmzasesores.com: "
                        class="btn btn-dos movil menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                            class="iconoAzul" />Mándanos un WhatsApp</a>
                    <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: "
                        class="btn btn-dos escritorio menos-margen"><img src="@/assets/images/whatsapp-azul.svg"
                            class="iconoAzul" />Mándanos un WhatsApp</a>
                    <a href="javascript:void('');" v-clipboard:copy="linkURL" class="btn btn-dos menos-margen"><img
                            src="@/assets/images/link-azul.svg" class="iconoAzul" />Copia
                        y comparte esta información</a>
                </div>
            </div>
            <div class="row fotoVideo my-5" v-if="pos == 'fotovideo'" data-aos="fade-up" data-aos-duration="1000">
                <div class="col-lg-5 text-left py-4">
                    <hr />
                    <h3 v-html="titulo"></h3>
                    <div class="texto" v-html="texto"></div>
                </div>
                <div class="col-lg-7 pl-lg-5 m-0">
                    <div class="embed-responsive embed-responsive-16by9">
                        <iframe class="embed-responsive-item" :src="'https://www.youtube.com/embed/' + video + '?rel=0'"
                            frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
                            allowfullscreen></iframe>
                    </div>
                </div>
                <div class="col-md-12">
                    <div class="row justify-content-center">
                        <div class="col-md-5 text-center">
                            <a href="tel:+523335633993" class="btn btn-primary">Llámanos por teléfono
                                <img src="@/assets/images/tel-azul.svg" class="iconoAzulDer" /></a>
                        </div>
                        <div class="col-md-5 text-center">
                            <a href="https://wa.me/523310735383?text=Web rmzasesores.com: "
                                class="btn btn-primary movil">Mándanos un WhatsApp<img
                                    src="@/assets/images/whatsapp-azul.svg" class="iconoAzulDer" /></a>
                            <a href="https://web.whatsapp.com/send?phone=523310735383?text=Web rmzasesores.com: "
                                class="btn btn-primary escritorio">Mándanos un WhatsApp<img
                                    src="@/assets/images/whatsapp-azul.svg" class="iconoAzulDer" /></a>
                        </div>
                        <div class="col-md-12 text-center mt-md-3">
                            <a href="javascript:void('');" v-clipboard:copy="linkURL" class="btn btn-primary">Copia y
                                comparte esta información<img src="@/assets/images/link-azul.svg"
                                    class="iconoAzulDer" /></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "FotoTextoLanding",
    props: {
        titulo: String,
        texto: String,
        linkURL: String,
        aviso: String,
        video: String,
        imagen: String,
        pos: String,
        id: String
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
hr {
    width: 30px;
    text-align: left;
    margin-top: 0;
    margin-bottom: 25px;
    margin-left: 0;
    border: 3px solid #00c4ff;
}

.aviso {
    color: #1900ff;
    font-weight: 600;
    height: 100%;
}

h3 {
    font-weight: 700;
    font-size: 24px;
}

.fotoArriba h3 {
    margin-top: 25px;
}

.flechalinks {
    height: 15px;
    margin-left: 10px;
}

.texto {
    padding: 20px 20px;
    font-size: 15px;
    font-weight: 400;
}

.fotoDerecha img {
    /*width: 460px;*/
}

.fotoIzquierda img {
    /*width: 460px;*/
}

.contImagen {
    position: relative;
}

.conAviso .contImagen {
    box-shadow: 10px 10px 0 #000;
}

.contImagen img {
    box-shadow: 10px 10px 0 #000;
}

.contImagen .embed-responsive {
    box-shadow: 10px 10px 0 #000;
}

.btn-primary {
    margin-top: 20px;
    margin-left: 20px;
    background-color: #fff !important;
    border-radius: 0;
    border: 4px solid #1900ff;
    padding: 6px 20px 6px 20px;
    color: #000;
    font-weight: 700;
    text-decoration: none;
    min-width: 315px;
}

.btn-primary:hover {
    background-color: #1900ff !important;
    color: #fff;
}

.btn-primary span {
    color: #1900ff;
    font-size: 30px;
    font-weight: 600;
    line-height: 20px;
    display: block;
    float: right;
    margin-top: 3px;
    margin-left: 20px;
}

.btn-primary:hover span {
    color: #fff;
}

.movil {
    display: none;
}

.escritorio {
    display: inline-block;
}

img.iconoAzul {
    width: 35px;
    margin-right: 20px;
}

img.iconoAzulDer {
    width: 35px;
    margin-left: 20px;
}

a.btn-dos {
    text-decoration: underline;
    font-weight: 600;
}

a.btn-dos:hover {
    color: #00c6ff;
}

@media only screen and (max-width: 990px) {
    .movil {
        display: inline-block;
    }

    a.btn-dos {
        font-size: 14px !important;
    }

    .escritorio {
        display: none;
    }

    .btn-primary {
        margin-left: 0;
        width: 100%;
        font-size: 14px;
        text-decoration: none;
        padding: 6px 10px 6px 10px;
    }

    h3 {
        font-size: 19px;
        margin-top: 15px;
        margin-left: 10px;
    }

    .texto {
        padding: 20px 30px;
    }

    .menos-margen {
        margin: 0 -50px;
    }
}
</style>
